<script>

export default {
    data() {
        return {
            checks: {},
        }
    },
    methods: {
        closedModal() {
            this.checks = {};
            this.$modal.hide('listChecks');
        },
    },
    created() {
        Event.$on("event-show-listChecks", (checks) => {
            if (checks) {
                this.checks = checks;
            }
            this.$modal.show('listChecks');
        });
    },
}
</script>
<template>
    <modal name="listChecks" :width="'80%'" :scrollable="true" :maxHeight="300" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Información de pagos</h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-12">
                    <div class="table-responsive">
                        <table class="table table-bordered text-center text-sm">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Tipo</th>
                                    <th>Proveedor</th>
                                    <th>Concepto</th>
                                    <th>Monto</th>
                                    <th>Fecha</th>
                                    <th>Tipo de saldo</th>
                                </tr>
                            </thead>
                            <tbody v-if="checks">
                                <tr v-for="(buy, index) in checks" :key="index">
                                    <td>{{ buy.id }}</td>
                                    <td>
                                        <span v-if="buy.type_id == 1"> Presupuesto </span>
                                        <span v-else> Compra </span>
                                    </td>
                                    <td>
                                        <span v-if="buy.provider"> {{ buy.provider.name }} {{ buy.provider.last_name
                                        }}</span>
                                        <span v-else>Sin proveedor</span>
                                    </td>
                                    <td>
                                        <span v-if="buy.concept"> {{ buy.concept.name }}</span>
                                        <span v-else>Sin Concepto</span>
                                    </td>
                                     <td>
                                        {{ buy.amount | toCurrency }}
                                    </td>
                                    <td>
                                        {{ buy.date }}
                                    </td>
                                   
                                    <td>
                                        <span v-if="buy.type_payment"> {{ buy.type_payment.name }}</span>
                                        <span v-else>Sin Tipo de Saldo</span>
                                    </td>                                  
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td align="center" colspan="5">Sin resultados.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12">
                    <hr>
                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>